// src/shared/utils/dateTimeUtils.ts

/**
 * Format date to DD/MM/YYYY (e.g., 24/04/2026)
 */
export const formatDate = (dateStr?: string): string => {
  if (!dateStr) return "";
  const d = new Date(dateStr);

  if (isNaN(d.getTime())) return ""; // invalid date safeguard

  return d.toLocaleDateString("en-GB");
};

/**
 * Format time to hh:mm:ss AM/PM (India format)
 */
export const formatTime = (dateStr?: string): string => {
  if (!dateStr) return "";
  const d = new Date(dateStr);

  if (isNaN(d.getTime())) return ""; // invalid date safeguard

  return d.toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true, // ensures AM/PM
  });
};

/**
 * Optional: Get both date & time together
 */
export const formatDateTime = (dateStr?: string): { date: string; time: string } => {
  return {
    date: formatDate(dateStr),
    time: formatTime(dateStr),
  };
};
